(() => {
  const initialize = container => {
    if (container.dataset.bagReady) return;
    const summary = container.querySelector('[data-bag-summary]');
    const inputs = Array.from(container.querySelectorAll('[data-bag-item]'));
    if (!summary || !inputs.length) return;
    container.dataset.bagReady = 'true';
    const home = container.closest('[data-howl-home]');
    const add = summary.querySelector('[data-bag-add]');
    const status = summary.querySelector('[data-bag-status]');
    const lines = summary.querySelector('[data-bag-lines]');
    const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const heading = summary.querySelector('[data-bag-heading]') || summary.querySelector('h3');
    const defaultHeading = summary.dataset.heading || heading?.textContent;
    const events = new AbortController();
    let busy = false;
    let uncertain = false;
    let lastAdded = null;
    let timer;
    let restoreCartBehavior = () => {};
    const keepBagOnPage = () => {
      restoreCartBehavior();
      const cart = window.Rebuy?.SmartCart;
      if (!cart) return;
      const previous = cart.skip_open;
      cart.skip_open = true;
      restoreCartBehavior = () => {
        if (cart.skip_open === true) cart.skip_open = previous;
        document.removeEventListener('pointerdown', restoreCartBehavior, true);
        document.removeEventListener('keydown', restoreCartBehavior, true);
        document.removeEventListener('click', restoreCartBehavior, true);
      };
      document.addEventListener('pointerdown', restoreCartBehavior, true);
      document.addEventListener('keydown', restoreCartBehavior, true);
      document.addEventListener('click', restoreCartBehavior, true);
    };
    const money = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: container.dataset.currency || 'USD' });
    const selection = () => inputs.filter(input => Number(input.value) > 0).map(input => ({input, id:Number(input.dataset.variant), quantity:Number(input.value), price:Number(input.dataset.price)}));
    const stopCelebration = () => { clearTimeout(timer); summary.classList.remove('is-celebrating'); };
    const render = () => {
      const selected = selection();
      const displayed = selected.length ? selected : lastAdded || [];
      if (heading) heading.textContent = lastAdded && !selected.length ? summary.dataset.added || defaultHeading : defaultHeading;
      lines.replaceChildren();
      displayed.forEach(item => {
        const line = document.createElement('li');
        const name = document.createElement('span');
        const price = document.createElement('span');
        name.textContent = `${item.quantity} × ${item.input.dataset.name}`;
        price.textContent = money.format(item.quantity * item.price / 100);
        line.append(name, price);
        lines.append(line);
      });
      inputs.forEach(input => {
        input.disabled = busy || uncertain;
        input.closest('.howl-treat-card').classList.toggle('is-selected', Number(input.value) > 0);
      });
      summary.querySelector('[data-bag-total]').textContent = money.format(displayed.reduce((sum,item) => sum + item.quantity * item.price, 0) / 100);
      summary.querySelector('[data-bag-empty]').hidden = displayed.length > 0;
      summary.querySelector('[data-bag-pickup]').hidden = !displayed.some(item => item.input.dataset.pickup === 'true');
      add.disabled = busy || uncertain || !selected.length;
      add.textContent = busy ? summary.dataset.adding : lastAdded && !selected.length ? summary.dataset.added || summary.dataset.add : summary.dataset.add;
      add.setAttribute('aria-busy', String(busy));
    };
    const refreshHeader = async () => {
      const response = await fetch(container.dataset.searchUrl, {credentials:'same-origin'});
      if (!response.ok) return;
      const page = new DOMParser().parseFromString(await response.text(), 'text/html');
      ['.page-header .header-cart', '.docked-navigation-container .header-cart'].forEach(selector => {
        const fresh = page.querySelector(selector);
        if (fresh) document.querySelectorAll(selector).forEach(current => current.replaceWith(fresh.cloneNode(true)));
      });
    };
    inputs.forEach(input => {
      input.closest('[data-bag-control]').hidden = false;
      input.addEventListener('change', () => { lastAdded = null; status.textContent = ''; stopCelebration(); render(); }, {signal:events.signal});
    });
    add.addEventListener('click', async () => {
      if (busy || uncertain || !selection().length) return;
      const selected = selection();
      busy = true;
      stopCelebration();
      status.textContent = summary.dataset.adding;
      render();
      keepBagOnPage();
      try {
        const response = await fetch(`${container.dataset.root}cart/add.js`, {
          method:'POST', credentials:'same-origin', headers:{'Content-Type':'application/json', 'Accept':'application/json'},
          body:JSON.stringify({items:selected.map(({id,quantity}) => ({id,quantity}))})
        });
        const data = await response.json();
        if (!response.ok) {
          if (response.status >= 500) uncertain = true;
          status.textContent = uncertain ? summary.dataset.uncertain : summary.dataset.error;
          refreshHeader().catch(() => {});
          return;
        }
        if (!Array.isArray(data.items) || !selected.every(item => data.items.some(added => Number(added.variant_id || added.id) === item.id))) {
          uncertain = true;
          status.textContent = summary.dataset.uncertain;
          refreshHeader().catch(() => {});
          return;
        }
        lastAdded = selected;
        inputs.forEach(input => { input.value = '0'; });
        status.textContent = summary.dataset.success;
        if (!motion.matches && home?.dataset.motion !== 'off' && !document.hidden) {
          summary.classList.add('is-celebrating');
          timer = window.setTimeout(stopCelebration, 4500);
        }
        refreshHeader().catch(() => {});
        container.dispatchEvent(new CustomEvent('wtpb:bag-added', {bubbles:true,detail:{items:selected.map(({id,quantity})=>({id,quantity}))}}));
      } catch (_) {
        uncertain = true;
        status.textContent = summary.dataset.uncertain;
      } finally {
        if (!lastAdded) restoreCartBehavior();
        busy = false;
        render();
      }
    }, {signal:events.signal});
    document.addEventListener('visibilitychange', () => { if(document.hidden) stopCelebration(); }, {signal:events.signal});
    motion.addEventListener('change', stopCelebration, {signal:events.signal});
    const observer = typeof IntersectionObserver === 'function' ? new IntersectionObserver(entries => {
      container.dataset.bagInView = String(entries.some(entry => entry.isIntersecting));
    }) : null;
    observer?.observe(container);
    document.addEventListener('shopify:section:unload', event => {
      if (event.target.contains(container)) { stopCelebration(); restoreCartBehavior(); observer?.disconnect(); events.abort(); delete container.dataset.bagInView; }
    }, {signal:events.signal});
    summary.hidden = false;
    render();
  };
  document.querySelectorAll('[data-howl-bag]').forEach(initialize);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-howl-bag]').forEach(initialize));
})();
